import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import {
    NgbActiveModal,
    NgbModule,
    NgbNavModule,
    NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { IconModule } from "@visurel/iconify-angular";
import { TranslateModule } from "@ngx-translate/core";
import { ClipboardModule } from "ngx-clipboard";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NgxSmarterplanCoreModule } from "@smarterplan/ngx-smarterplan-core";
import { ErrorComponent } from "../components/error/error.component";
import * as config from "../../assets/json-config/dev.json";
import { DashboardHeaderComponent } from "../components/dashboard-header/dashboard-header.component";
import { ChevronComponent } from "../components/chevron/chevron.component";

@NgModule({
    imports: [
        CommonModule,
        NgbNavModule,
        IconModule,
        NgbModule,
        NgSelectModule,
        NgbTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,
        ClipboardModule,
        PdfViewerModule,
        NgxSmarterplanCoreModule.forRoot({ my_config: config }),
    ],
    declarations: [
        // components
        ErrorComponent,
        DashboardHeaderComponent,
        ChevronComponent,
    ],
    exports: [
        // ---Modules
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        RouterModule,
        NgbTooltipModule,
        NgbNavModule,
        IconModule,
        NgbModule,
        TranslateModule,
        ClipboardModule,
        PdfViewerModule,
        NgxSmarterplanCoreModule,

        // ---Components
        ErrorComponent,
        DashboardHeaderComponent,
        ChevronComponent,
    ],
    providers: [NgbActiveModal],
})
export class SharedModule { }
